import React, { useState } from 'react';
import styles from '../styles/stylesPortfolioCardMobile';

function PortfolioCardMobile({
  image,
  icon,
  title,
  subtitle,
  link,
  topImage,
  topImageOffset,
  gradientImage,
  topImageHeight
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        ...styles.cardOuterBorder,
        ...(isHovered ? styles.cardOuterBorderHover : {}),
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.iconWrapper}>
        <img src={icon} alt="Project Icon" style={styles.icon} />
      </div>

      <div style={styles.card}>
        <img src={gradientImage} alt="Gradient Background" style={styles.cardImage} />
        <div style={{ ...styles.cardBlur, filter: 'opacity(1)' }}></div>

        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.projectImageWrapper}
        >
          <img src={image} alt="Project Preview" style={styles.projectImage} />
        </a>

        <div style={styles.projectTitleWrapper}>
          <div style={styles.projectTitleBold}>{title}</div>
          <div style={styles.projectSubtitle}>{subtitle}</div>
        </div>

        {topImage && (
          <div
            style={{
              ...styles.topImageWrapper,
              transform: `translate(-50%, ${topImageOffset})`,
            }}
          >
            <img
              src={topImage}
              alt="Mockup"
              style={{
                ...styles.topImage,
                ...(topImageHeight ? { height: topImageHeight } : {}), // 👈 aplica somente no mobile
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default PortfolioCardMobile;
